import { inject } from '@angular/core';
import { AppConfigService, AppVersion, AuthenticationService } from '@sphere/platform';
import { spherePlatformApps } from '../__app-registration';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { DYNAMIC_SPHERE_CONFIG } from '../sphere-app.config';
import appPackage from '../../../../../package.json';

export function sphereInitializer() {
    return async () => {
        console.debug(`running sphereInitializer...`);
        const appConfigService = inject(AppConfigService);
        const authClientConfig = inject(AuthClientConfig);
        const authentication = inject(AuthenticationService);
        const CONFIG = inject(DYNAMIC_SPHERE_CONFIG);
        try {
            const appVersion: AppVersion = {
                appVersion: appPackage.version,
                platformVersion: appPackage.platformVersion,
                commit: CONFIG.build.commit
            };
            appConfigService.init(CONFIG, appVersion, spherePlatformApps.sphereAppRoutes);
            authClientConfig.set({
                ...appConfigService.auth0Configuration,
                authorizationParams: {
                    redirect_uri: window.location.origin,
                    audience: CONFIG.auth0.audience || 'https://api.enverus.com'
                }
            });
            console.debug(`[AuthenticationService] Preparing provider services...`);
            await authentication.prepareServices();
        } catch (e) {
            console.error(e);
        }
    };
}
